<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-bottom="51"
    bottom
    :max-width="menuWidth"
    :min-width="menuWidth"
    max-height="70vh"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :style="cssVariables"
        filled
        hide-details
        clearable
        outlined
        color="primary"
        dense
        v-on="on"
        :placeholder="
          $vuetify.breakpoint.xsOnly
            ? $translate('SEARCH')
            : $translate('SEARCH_SENTENCE')
        "
        v-model="query"
        @input="onSearch"
        @click:clear="query = ''"
        @click="onInputClick"
        class="searchBar"
      >
        <v-icon class="hidden-sm-and-down" slot="append" color="primary">
          mdi-magnify
        </v-icon>
      </v-text-field>
    </template>

    <v-card width="100%" height="100%">
      <v-row no-gutters :class="hasSearchResults ? '' : 'd-none'">
        <v-col
          cols="12"
          class="pa-0"
          :class="hasProducts ? '' : 'd-none'"
          :order="productFocused ? 1 : 2"
        >
          <!-- Product focused -->
          <SearchResults
            ref="productSearchResults"
            :trendingActive="trendingActive"
            :results="searchProducts"
            :searchString="query"
            @hideEvents="hideEvents"
            @showEvents="showEvents"
            @hideSearchMenu="hideSearchMenu"
          />
        </v-col>
        <v-col
          cols="12"
          class="pa-0"
          :class="eventsAreVisible && hasEvents ? '' : 'd-none'"
          :order="productFocused ? 2 : 1"
        >
          <!-- Event focused -->
          <SearchResultsEventList
            :trendingActive="trendingActive"
            :results="searchEvents"
            @hideSearchMenu="hideSearchMenu"
          />
        </v-col>
      </v-row>

      <!-- Text for no results -->
      <div
        class="text-body-2 text--secondary pa-3"
        :class="hasSearchResults ? 'd-none' : ''"
      >
        0 {{ $translate('RESULTS') }}
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchResults from '@/components/homepage/SearchResults';
import SearchResultsEventList from '@/components/homepage/SearchResults_EventList';
import doRequest from '@/api/dssRequest';

export default {
  name: 'search',
  components: {
    SearchResults,
    SearchResultsEventList,
  },
  data() {
    return {
      query: '',
      trendingActive: false,
      searchProducts: [],
      searchEvents: [],
      menu: false,
      eventsAreVisible: true,
    };
  },
  computed: {
    ...mapGetters({
      userId: 'auth/userName',
    }),
    partnerGroupDetails() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
    productFocused() {
      if (
        this.partnerGroupDetails == null ||
        this.partnerGroupDetails.Focus == null
      ) {
        return true;
      }

      if (this.partnerGroupDetails.Focus === 'Product') {
        return true;
      }

      return false;
    },
    cssVariables() {
      return {
        '--primary-color': this.$vuetify.theme.themes.light.primary,
      };
    },
    hasSearchResults() {
      if (
        (this.searchProducts != null && this.searchProducts.length > 0) ||
        (this.searchEvents != null && this.searchEvents.length > 0)
      ) {
        return true;
      }
      return false;
    },
    hasProducts() {
      if (this.searchProducts != null && this.searchProducts.length > 0) {
        return true;
      }
      return false;
    },
    hasEvents() {
      if (this.searchEvents != null && this.searchEvents.length > 0) {
        return true;
      }
      return false;
    },
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return false;
        case 'sm':
          return false;
        case 'md':
          return true;
        case 'lg':
          return true;
        case 'xl':
          return true;
        default:
          return true;
      }
    },
    menuWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return '100vw';
        case 'md':
        case 'lg':
        case 'xl':
        default:
          return '800px';
      }
    },
  },
  created() {
    window.EventBus.listen('hideSearchMenu', this.hideSearchMenu);
  },
  beforeDestroy() {
    window.EventBus.removeListener('hideSearchMenu', this.hideSearchMenu);
  },
  methods: {
    setMenuToDefault() {
      if (this.$refs.productSearchResults != null) {
        this.$refs.productSearchResults.currentComponent = 'List';
      }

      this.showEvents();
    },
    hideSearchMenu() {
      this.setMenuToDefault();
      // close the menu
      this.menu = false;
    },
    hideEvents() {
      this.eventsAreVisible = false;
    },
    showEvents() {
      this.eventsAreVisible = true;
    },
    onInputClick() {
      if (this.query != null && this.query !== '') {
        return;
      }

      this.getTrendingProducts();
      this.getTrendingEvents();
    },
    getTrendingProducts() {
      const object = this.$store.getters['auth/userObjectId'];
      const payload = {};
      this.searchProducts = [];

      doRequest(
        (response) => {
          // set the trendingActive to true to show the trendingsitems and hide the search results
          this.trendingActive = true;

          this.searchProducts = response.data.TrendingProducts;
        },
        () => {},
        'getTrendingProducts',
        object,
        payload,
        'GET'
      );
    },
    getTrendingEvents() {
      const payload = {};
      this.searchEvents = [];

      doRequest(
        (response) => {
          // set the trendingActive to true to show the trendingsitems and hide the search results
          this.trendingActive = true;
          this.searchEvents = response.data.TrendingEvents;
        },
        () => {},
        'getTrendingEvents',
        'LocationsNode_ESE',
        payload,
        'GET'
      );
    },
    onSearch() {
      // set the productDetails view to list again to get your results
      if (
        this.$refs.productSearchResults != null &&
        this.$refs.productSearchResults.currentComponent !== 'List'
      ) {
        this.setMenuToDefault();
      }

      if ((this.query == null || this.query === '') && this.imageHeight) {
        this.menu = false;
      } else {
        this.menu = true;

        // set the written characters in a variable
        const query = this.query;
        /*
          timeout is to check if the characters is still the same and than do a call
          this is to prevent that you do for every character a call
         */
        setTimeout(() => {
          if (query === this.query) {
            this.searchItems();
          }
        }, 400);
      }
    },
    searchItems() {
      if (this.query != null && this.query !== '') {
        const query = this.query;

        const payload = {
          IncludeAllPartnersInPartnerGroup: true,
          MatchName: query,
        };

        const object = this.$store.getters['auth/userObjectId'];

        this.searchProducts = [];
        this.searchEvents = [];

        doRequest(
          (response) => {
            /*
            if we don't check if the query is still the same the search has a bug
            because if you type a word you first receive more results than later
            and if you are typing fast you receive first the less results than
            the most results so your search won't work than
            */
            if (query !== this.query) {
              return;
            }

            this.searchProducts = response.data.Products;
            this.searchEvents = response.data.Events;

            // set the trendingActive to false to hide the trendingItems and show the search results
            this.trendingActive = false;
          },
          () => {},
          'search',
          object,
          payload,
          'GET'
        );
      } else {
        this.onInputClick();
      }
    },
  },
};
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  background-color: white;
  border: 1px solid var(--primary-color);
}
.searchBar {
  width: 15vw;
}
</style>
